import React, { useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import UserListTable from "./UserListTable";

const countUsers = (list, idKey, idValue) => list.filter((user) => user[idKey] === idValue).length;

const truncateText = (text, maxLength = 20) => {
  if (typeof text !== "string") {
    return "";
  }

  return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
};

const GenericTabView = ({
  items,
  fieldname,
  renderOverview,
  data,
  canUpdatePrice,
  onUpdatePrice,
  getColumnField,
  getColumnBody,
  isColumnSortable
}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <TabView
      activeIndex={activeIndex}
      onTabChange={(e) => {
        setActiveIndex(e.index);
      }}
      scrollable
    >
      {items.map((item, index) => {
        const userCount = countUsers(data.users, fieldname, item[fieldname]);
        const filteredUsers = data.users?.filter((user) => user[fieldname] === item[fieldname]) || [];

        return (
          <TabPanel key={`chapitre-${index}`} header={truncateText(item.Name)}>
            <div className="grid ui-fluid ">
              {renderOverview(item)}
              <UserListTable
                users={filteredUsers}
                title={`Participants: (${userCount})`}
                emptyMessage="No members in this chapitre."
                downloadFilename={`chapitre_${item[fieldname]}`}
                canUpdatePrice={canUpdatePrice}
                onUpdatePrice={onUpdatePrice}
                isColumnSortable={isColumnSortable}
                getColumnField={getColumnField}
                getColumnBody={getColumnBody}
              />
            </div>
          </TabPanel>
        );
      })}
    </TabView>
  );
};

export default GenericTabView;
